import { AlertTypeKey } from '../models/client/constants'

export const ALERT_LABEL_CONTENT: Record<AlertTypeKey, { key: AlertTypeKey; label: string }> = {
    assetArrivalId: {
        key: 'assetArrivalId',
        label: 'Asset Arrival ID',
    },
    assetArrivalTime: {
        key: 'assetArrivalTime',
        label: 'Asset Arrival Time',
    },
    assetDepartureTime: {
        key: 'assetDepartureTime',
        label: 'Asset Departure Time',
    },
    assetMaxDwellTime: {
        key: 'assetMaxDwellTime',
        label: 'Asset Max Dwell Time',
    },
}

export const VALIDATION_MSG_REQUIRED = 'required'
export const VALIDATION_MSG_INVALID_EMAIL = 'invalid email'
